import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61.9 62.51" width="1em" height="1em">
    <defs>
      <clipPath id="prefix__a">
        <path fill="none" d="M15.95 4.7h30v30h-30z" />
      </clipPath>
    </defs>
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <path fill="fj-icons-primary-color" d="M.76 28.73l30.4 17.54 29.99-17.54H.76z" />
        <path
          fill="fj-icons-bg-color"
          stroke="fj-icons-primary-color"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.51}
          d="M.76 28.73L30.95 1.76l30.2 26.97"
        />
        <path
          d="M12.18.75h37.44A2.42 2.42 0 0152 3.17v48.19h0H9.76h0V3.17A2.42 2.42 0 0112.18.75z"
          fill="fj-icons-bg-color"
          stroke="fj-icons-primary-color"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.51}
        />
        <path
          d="M31.16 46.27L.75 28.73v30.54a2.5 2.5 0 002.49 2.49h55.42a2.5 2.5 0 002.49-2.49V28.73z"
          fill="fj-icons-bg-color"
          stroke="fj-icons-primary-color"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.51}
        />
        <path fill="#7f1416" d="M32.11 13.45l1.43 2.96 12.41-3.47v-4.4l-13.84 4.91z" />
        <path fill="#be2026" d="M33.54 16.41l1.44 2.76 10.97-2.28v-3.95l-12.41 3.47z" />
        <g clipPath="url(#prefix__a)">
          <path d="M46 16.89v3.58l-9.59 1.29L35 19.11z" fill="#dc4326" />
          <path
            d="M21.91 18l7.46 3L28 4.73 21.91 18M28 34.73l-12-4.28v-.06l3.39-7.11s9.27 2.89 9.26 2.91z"
            fill="#58595b"
          />
          <path d="M28 34.73v-30l13.21 25-13.22 5" fill="#939598" />
          <path fill="#7f1416" d="M28 20.33l-6.09-2.36-.81 1.63 6.9 2.56v-1.83z" />
          <path fill="#be2026" d="M28 22.16l-6.9-2.56-.85 1.78L28 24.03v-1.87z" />
          <path fill="#dc4326" d="M28 26.05l-8.59-2.77.84-1.9L28 24.03v2.02z" />
        </g>
      </g>
    </g>
  </svg>
);

const InvitesFlowjo = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default InvitesFlowjo;
